import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { Text } from '../text'

export type DateBlockProps = {
    /** The timestamp / date text, already formatted (e.g. `27.11.2024 15:04`). */
    value: string
    className?: string
    testID?: string
}

/**
 * The "last updated" timestamp chip (Figma Mobile/DateBlock `4192:7676`): a compact
 * `bg/surface` chip holding a formatted timestamp in P4-Medium 12 `content/default` ink.
 * Pass `className` to override the background on a surface that already uses
 * `bg-aos-bg-surface`. Presentational + cross-platform.
 */
export const DateBlock: React.FC<DateBlockProps> = ({ value, className, testID }) => (
    <Box
        className={twMerge(
            'self-start flex-row items-center justify-center rounded bg-aos-bg-surface px-4 py-1.5',
            className,
        )}
        testID={testID}
    >
        <Text size='caption' weight='medium' tone='default' className='text-center'>
            {value}
        </Text>
    </Box>
)

DateBlock.displayName = 'DateBlock'
